// Local translations
export const T = {
  en_GB: {
    edit: "Edit",
    deleteTenant: "Delete Tenant",
    deleteConfirmation: "Are you sure you want to delete",
    cannotBeUndone: "This action cannot be undone.",
    delete: "Delete",
    cancel: "Cancel",
    error: "Error",
    failedToDeleteTenant: "Failed to delete tenant",
    ok: "OK",
    noTenantsYet: "No tenants yet. Create your first tenant to get started.",
    name: "Name",
    slug: "Slug",
    partner: "Partner",
    owner: "Owner",
    actions: "Actions",
    users: "Users",
  },
  nb_NO: {
    edit: "Rediger",
    deleteTenant: "Slett organisasjon",
    deleteConfirmation: "Er du sikker på at du vil slette",
    cannotBeUndone: "Denne handlingen kan ikke angres.",
    delete: "Slett",
    cancel: "Avbryt",
    error: "Feil",
    failedToDeleteTenant: "Kunne ikke slette organisasjon",
    ok: "OK",
    noTenantsYet: "Ingen organisasjoner ennå. Opprett din første organisasjon for å komme i gang.",
    name: "Navn",
    slug: "Slug",
    partner: "Partner",
    owner: "Eier",
    actions: "Handlinger",
    users: "Brukere",
  },
} as const;
